// @ts-nocheck
import ContentOverlay from "~/content.overlay";
import ReviewsList from "~/reviewslist/index";
import Canonical from "~/canonical";

Mapy.ReviewsListContent = class extends ContentOverlay {
	constructor() {
		super();
		this._contentName = "reviews-list";
		this._reviewsList = new ReviewsList(this);
		this._dom = {
			container: this._reviewsList.container,
		};
		this._buildCloseButton();
	}

	activate() {
		if (this.isActive()) {
			return this;
		}

		this._reviewsList.activate();

		// nastavime canonical na to, co je + recenze
		try {
			const url = new URL(Canonical.get());

			url.searchParams.set("recenze", "1");
			Canonical.set("/", url.searchParams);
		} catch (exc) {
			// eslint-disable-next-line no-console
			console.log(exc);
		}

		return super.activate();
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		this._reviewsList.deactivate();
		super.deactivate();

		// nastavime canonical na to, co je + recenze
		try {
			const url = new URL(Canonical.get());

			url.searchParams.delete("recenze");
			Canonical.set("/", url.searchParams);
		} catch (exc) {
			// eslint-disable-next-line no-console
			console.log(exc);
		}

		Mapy.getComponent("history").save();

		return this;
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);

		return super.show();
	}

	hide() {
		return super.hide();
	}

	getState() {
		return this._reviewsList.getState();
	}

	setState(state) {
		this._reviewsList.setState(state);
		super.setState();

		return this;
	}

	removeMyReview(newReview) {
		this._reviewsList.removeMyReview(newReview);
	}
};
